import React from 'react'

import PropTypes from 'prop-types'

import { makeStyles, useTheme } from '@mui/styles'

import CustomerPrivatMan from '@assets/images/customer-private-man2.svg'
import CustomerPrivatWoman from '@assets/images/customer-private-woman2.svg'
import CustomerPrivatFamily from '@assets/images/customer-private-family2.svg'
import CustomerCompany from '@assets/images/company.svg'
import SupplierAvatar from '@assets/images/supplier.svg'
import FileAvatar from '@assets/images/file.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const useStyles = makeStyles(theme => ({
  svgIcon: {
    display: 'inline-flex',
    '& circle': {
      fill: '#63849e',
    },
    '& text': {
      fill: '#fff',
    },
  },
}))

const Named = ({ name, ...rest }) => {
  const theme = useTheme()
  return (
    <svg {...rest} fill={theme.iconFillColor} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150.462 150.462">
      <g id="icon-firma" transform="translate(-471 -147)">
        <circle id="Ellipse_7" data-name="Ellipse 7" cx="75.231" cy="75.231" r="75.231" transform="translate(471 147)" />
        <g id="factory" transform="translate(505 166.112)">
          <text id="initials" x="40" y="80" text-anchor="middle" font-size="75">{name}</text>
        </g>
      </g>
    </svg>
  )
}

const Avatar = (props) => {
  const classes = useStyles()
  const { kind, salutation, width = 150, className } = props

  let svg = null
  if (kind === 'person') {
    if (salutation === 'Familie') {
      svg = CustomerPrivatFamily
    } else {
      svg = salutation === 'Frau' ? CustomerPrivatWoman : CustomerPrivatMan
    }
  } else if (kind === 'company') {
    svg = CustomerCompany
  } else if (kind === 'supplier') {
    svg = SupplierAvatar
  } else if (kind === 'file') {
    svg = FileAvatar
  } else if (kind === 'name') {
    const initials = salutation
      ? salutation.split(' ').filter(Boolean).reduce((result, token) => {
        if (result.length < 2) {
          result += token[0]
        }
        return result
      }, '').toUpperCase()
      : ''
    svg = <Named className={classes.svgIcon} name={initials} width={width} />
  }

  return (
    <div className={className}>
      {svg && kind !== 'name' && <SVGIcon className={classes.svgIcon} width={width} svg={svg} />}
      {svg && kind === 'name' && svg}
    </div>
  )
}

Avatar.propTypes = {
  kind: PropTypes.string.isRequired,
  salutation: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
}

export default Avatar
